<template>
	<div class="home">
		<div class="head max-width">
			<!-- 头部banner-->
			<div class="head-img">
				<img :src="headImgUrl" />
			</div>
			<!-- 导航栏-->
			<div class="head-nav">
				<div class="sub-nav" v-for="(item,index) in navList" :key="index" @click="goLink(item.link)">
					{{item.title}}
				</div>
			</div>
		</div>

		<!-- 展厅背景图-->
		<div class="bg">
			<div class="bg-center">
				<h3>线上展厅</h3>
			</div>
			<div class="bg-btm"></div>
		</div>

		<!-- 地图指引-->
		<div class="map-menu max-width">
			<div class="map-menu-box">
				<div class="map-menu-left">
					<div class="map-icon">
						<img src="../../static/image/map-icon.png" />
					</div>
					<div class="map-info">
						您在这里：
						<span class="map-nav">{{mapInfo.nav}}</span>
						<span class="map-line">/</span>
						<span class="map-title">{{mapInfo.title}}</span>
					</div>
				</div>
				<div class="map-menu-right">{{mapInfo.msg}}</div>
			</div>
		</div>


		<div class="content max-width">
			<!-- 分类-->
			<div class="cate">
				<div class="cate-search">
					<div class="cate-search-title">所有分类</div>
					<div class="cate-search-select">
						<select class="search-select" name="menuType" @change="onChangeType($event,menuTypeList)">
							<option :value="de.type" v-for="de in menuTypeList">{{ de.name }}</option>
						</select>
					</div>
					<div class="cate-search-input">
						<div class="search-input">
							<input type="text" v-model="keyword" placeholder="请输入产品/品牌名称" />
						</div>
						<div class="search-icon" @click="goSearch()">
							<img src="../../static/image/search-icon.png" />
						</div>
					</div>
				</div>
				<div class="cate-info">
					<div class="sub-cate" v-for="(item,index) in cateList" :key='index'>
						<img :src="item.cover" />
						<div class="sub-cate-box" @click="toUrl(item.link)">
							<div class="sun-cate-icon">
								<img src="../../static/image/hjzs-icon.png" v-if="item.title == '获奖展商'" />
								<img src="../../static/image/zqzp-icon.png" v-else-if="item.title == '展区展品'" />
								<img src="../../static/image/czs-icon.png" v-else />
							</div>
							<div class="sub-cate-title">{{item.title}}</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 热门-->
			<div class="hot">
				<div class="sub-hot">
					<!-- 热门企业-->
					<div class="hot-title">
						<div class="hot-title-left-line"></div>
						<div class="hot-title-text">热门企业</div>
						<div class="hot-title-right-line"></div>
					</div>
					<div class="hot-swiper">
						<swiper :options="swiperOption" v-if="hotCom.length > 0">
							<swiper-slide v-for="(item, index) in hotCom" :key="index">
								<div class="com-list">
									<div class="sub-com" v-for="(itemNew, indexNew) in item.list" :key="indexNew"
										@click="goExhibitors('exhibitorsDetail',itemNew.id)">
										<img :src="itemNew.images" />
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination paginationBanner" slot="pagination"></div>
						</swiper>
					</div>
				</div>
				<!-- <div class="sub-hot"> -->
				<!-- 热门展品-->
				<!-- <div class="hot-title">
            <div class="hot-title-text">热门企业</div>
            <div class="hot-title-line"></div>
          </div>
          <div class="hot-swiper">
            <swiper :options="swiperOption" v-if="hotPro.length > 0">
              <swiper-slide v-for="(item, index) in hotPro" :key="index">
                <ul class="home-ul">
                  <li class="home-li" v-for="(itemNew,indexNew) in item.list" :key="indexNew" @click="goPro('exhibitsDetail',itemNew.goods_id)">
                    <div class="pro-cover">
                      <img :src="itemNew.images" />
                    </div>
                    <div class="pro-num">{{itemNew.num}}</div>
                    <div class="home-pro-name">{{itemNew.goods_name}}</div>
                  </li>
                </ul>
              </swiper-slide>
              <div class="swiper-pagination paginationBanner" slot="pagination"></div>
            </swiper>
          </div>
        </div> -->
			</div>
		</div>

		<!-- 底部-->
		<div class="footer">
			<div class="footer-box max-width">
				<div class="footer-left">
					<div class="footer-company">{{footer.companyInfo.name}}</div>
					<div class="footer-tip">{{footer.companyInfo.tip}}</div>
				</div>
				<div class="footer-center">
					<img :src="footer.codeUrl" />
				</div>
				<div class="footer-right">
					<div class="footer-phone">
						<span class="footer-title">{{footer.phone}}</span>
						<img class="footer-icon" src="../../static/image/footer-phone-icon.png" />
					</div>
					<div class="footer-mobile">
						<span class="footer-title">{{footer.mobile}}</span>
						<img class="footer-icon" src="../../static/image/footer-mobile-icon.png" />
					</div>
					<div class="footer-email">
						<span class="footer-title">{{footer.email}}</span>
						<img class="footer-icon" src="../../static/image/footer-email-icon.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import '../assets/css/swiper.min.css';
	export default {
		name: 'home',
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				menuTypeList: [{
						'type': 1,
						'name': '展位号'
					},
					{
						'type': 2,
						'name': '参展商'
					},
					{
						'type': 3,
						'name': '产品'
					},
				],
				menuType: 1,
				headImgUrl: 'https://www.ywwjz.com/assets/img/head_logo.png',
				navList: [{
					'title': '首页',
					'link': 'https://www.ywwjz.com'
				}, {
					'title': '展会信息',
					'link': 'https://www.ywwjz.com/p/aboutus'
				}, {
					'title': '线上展厅',
					'link': 'https://www.ywwjz.com/wszt.html#/home'
				}, {
					'title': '展会新闻',
					'link': 'https://www.ywwjz.com/c/zhxw.html'
				}, {
					'title': '联系我们 ',
					'link': 'https://www.ywwjz.com/d/message.html'
				}],
				mapInfo: {
					nav: '首页',
					title: '网上展厅',
					msg: '温馨提示：以下展品展示，仅供参考'
				},
				cateList: [{
					cover: 'https://www.ciie.org/resource/static/zbh/default/assets/img/yuzhan/trophy_06.png',
					title: '获奖展商',
					link: '/exhibitorsList'
				}, {
					cover: 'https://www.ciie.org/resource/static/zbh/default/assets/img/yuzhan/trophy_06.png',
					title: '展区展品',
					link: '/exhibits'
				}, {
					cover: 'https://www.ciie.org/resource/static/zbh/default/assets/img/yuzhan/trophy_06.png',
					title: '参展商',
					link: '/exhibitorsList'
				}],
				hotCom: [],
				hotPro: [],
				swiperOption: {
					pagination: {
						el: ".paginationBanner",
						clickable: true
					},
					autoplay: {
						disableOnInteraction: false,
						delay: 5000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				footer: {
					companyInfo: {
						name: '中国义乌文具礼品展览会',
						tip: 'CHINA YIWU STATIONERY&GIFT EXHIBITION'
					},
					codeUrl: 'https://www.ywwjz.com/uploads/20200512/4dce8c3bbb75345f7dea9c5ba5c81f60.png',
					phone: '0579—85163311',
					mobile: '18867567324',
					email: '964959387@qq.com'
				},
				keyword: ''
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				const that = this;
				var api = 'https://www.ywwjz.com/addons/litestore/api.index/index';
				that.$http.get(api).then((res) => {
					// 响应成功回调
					if (res.body.code == 1) {
						that.hotCom = res.body.data.exhibitors;
						that.hotPro = res.body.data.hotPro;
					} else {
						console.log('获取数据失败')
					}
				}, (error) => {
					// 响应错误回调
					console.log(error);
				});
			},
			//跳转地址
			goLink(url) {
				window.location.href = url
			},
			//路由跳转
			toUrl(url) {
				this.$router.push({
					path: url
				})
			},
			//展商详情
			goExhibitors(url, id) {
				this.$router.push({
					name: url,
					query: {
						id: id
					}
				})
			},
			goPro(url, id) {
				this.$router.push({
					name: url,
					query: {
						id: id
					}
				});
			},
			//搜索跳转
			goSearch() {
				var url = this.menuType == 3 ? 'exhibits' : 'exhibitorsList';
				this.$router.push({
					name: url,
					query: {
						type: this.menuType,
						title: this.keyword
					}
				})
			},
			// 条线改变事件
			onChangeType: function(e, value) {
				this.menuType = e.target.value;
			},
		}
	}
</script>
<style>
	body {
		margin: 0;
	}

	.max-width {
		max-width: 1200px;
		margin: 0 auto;
	}

	.head-img {
		margin-bottom: 9px;
	}

	.head-img img {
		width: 100%;
		display: block;
	}

	.head-nav {
		overflow: hidden;
		height: 50px;
		line-height: 50px;
		text-align: center;
		background: #046575;
		color: #FFFFFF;
		font-size: 16px;
		font-weight: bolder;
		letter-spacing: 5px;
	}

	.sub-nav {
		width: 20%;
		float: left;
		color: white;
		font-weight: bold;
		font-size: 18px;
		letter-spacing: 0px;
	}

	.sub-nav:hover {
		background: #13b5b1;
		cursor: pointer;
	}

	.swiper-pagination-bullet-active {
		background: #046575;
	}

	.bg {
		background: url(https://www.ciie.org/resource/static/zbh/default/assets-2019/img/innerbannerbg.png) center;
		background-size: cover;
		min-height: 240px;
		overflow: hidden;
		position: relative;
		width: 100%;
	}

	.bg-center {
		max-width: 1200px;
		margin: 0 auto;
		text-align: center;
		color: #FFFFFF;
		font-size: 30px;
		font-weight: bolder;
	}

	.bg-center h3 {
		margin-top: 80px;
	}

	.bg-btm {
		background: url(https://www.ciie.org/resource/static/zbh/default/assets-2019/img/svg326.png) 0 top;
		background-size: 100%;
		position: absolute;
		width: 100%;
		bottom: 0;
		z-index: 0;
		height: 48px;
	}

	.map-menu {
		height: 60px;
		line-height: 60px;
		padding: 0 15px;
		color: #666666;
	}

	.map-menu-box {
		overflow: hidden;
		border-bottom: 2px solid rgba(0, 0, 0, 0.07);
	}

	.map-menu-left {
		float: left;
		overflow: hidden;
	}

	.map-icon {
		float: left;
		width: 20px;
		height: 20px;
		position: relative;
		top: 20px;
		margin-right: 20px;
	}

	.map-icon img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.map-info {
		float: left;
	}

	.map-nav {
		color: #66aeff;
		cursor: pointer;
	}

	.map-line {
		margin: 0 5px;
		color: #cccccc;
	}

	.map-menu-right {
		float: right;
		color: #ff5503;
	}

	.content {
		padding-top: 30px;
		min-height: 600px;
	}

	.cate-search {
		overflow: hidden;
		background: #046575;
		height: 36px;
		line-height: 36px;
		padding: 10px 0;
	}

	.cate-search-title {
		width: 16%;
		float: left;
		color: #FFFFFF;
		cursor: pointer;
		text-align: center;
		font-size: 20px;
		font-weight: 700;
	}

	.cate-search-select {
		width: 16%;
		float: left;
		cursor: pointer;
	}

	.search-select {
		width: 100%;
		height: 36px;
		border: none;
		border-radius: 10px;
		padding: 0 10px;
		color: #666666;
		cursor: pointer;
	}

	.cate-search-input {
		width: calc(30% - 15px);
		padding-right: 15px;
		float: right;
		overflow: hidden;
	}

	.search-input {
		width: calc(100% - 36px);
		float: left;
	}

	.search-input input {
		width: 100%;
		height: 36px;
		line-height: 36px;
		border: none;
		padding: 0 0 0 10px;
		margin: 0;
		display: block;
	}

	.search-icon {
		float: left;
		width: 16px;
		height: 16px;
		background: #d9dee2;
		padding: 10px;
		cursor: pointer;
	}

	.search-icon:hover {
		background: #FFC107;
	}

	.search-icon img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.cate-info {
		overflow: hidden;
		padding: 15px 0;
	}

	.sub-cate {
		width: calc((100% - 30px) / 3);
		height: 131px;
		float: left;
		margin-right: 15px;
		position: relative;
	}

	.sub-cate:last-child {
		margin-right: 0;
	}

	.sub-cate img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.sub-cate-box {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .4);
		text-align: center;
		font-size: 20px;
		color: #FFFFFF;
		font-weight: bold;
		cursor: pointer;
	}

	.sun-cate-icon {
		width: 50px;
		height: 50px;
		margin: 20px auto 0 auto;
	}

	.sun-cate-icon img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.hot {
		overflow: hidden;
	}



	.sub-hot:first-child {
		margin-right: 15px;
	}

	.sub-hot:last-child {
		margin-left: 15px;
	}

	.hot-title {
		margin-bottom: 15px;
		overflow: hidden;
	}

	.hot-title-text {
		width: 20%;
		height: 32px;
		line-height: 32px;
		color: #046575;
		text-align: center;
		font-size: 24px;
		font-weight: bold;
		display: inline-block;
	}

	.hot-title-left-line {
		width: 40%;
		float: left;
		height: 16px;
		background: #e9e9e9;
		margin: 8px 0 0 0;
		display: inline-block;
	}

	.hot-title-right-line {
		width: 40%;
		float: right;
		height: 16px;
		background: #e9e9e9;
		margin: 8px 0 0 0;
		display: inline-block;
	}

	.com-list {
		overflow: hidden;
	}

	.sub-com {
		float: left;
		padding: 0 5px;
		margin-bottom: 10px;
		width: calc((100% - 30px) / 3);
		display: table-cell;
		vertical-align: middle;
		height: 160px;
		cursor: pointer;
	}

	.sub-com img {
		width: 100%;
		height: 100%;
	}

	.home-ul {
		list-style-type: none;
		padding: 0;
		margin: 0;
	}

	.home-li {
		background: #eee;
		margin-bottom: 10px;
		border-radius: 10px;
		overflow: hidden;
		padding: 5px;
		cursor: pointer;
	}

	.home-li:last-child {
		margin-bottom: 0;
	}

	.pro-cover {
		float: left;
		width: 100px;
		height: 100px;
		padding: 5px;
		border-radius: 50%;
	}

	.pro-cover img {
		width: 100%;
		height: 100%;
		display: block;
		border: 2px solid #FFFFFF;
		border-radius: 50%;
	}

	.pro-num {
		float: left;
		width: 40px;
		height: 110px;
		line-height: 110px;
		text-align: center;
		font-size: 46px;
		font-weight: 700;
		padding: 0 5px;
	}

	.home-li:nth-child(1) .pro-num {
		color: #e74240;
	}

	.home-li:nth-child(2) .pro-num {
		color: #ed713d;
	}

	.home-li:nth-child(3) .pro-num {
		color: #feb185;
	}

	.home-pro-name {
		float: left;
		width: calc(100% - 162px);
		height: 110px;
		line-height: 110px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.footer {
		margin-top: 50px;
		background: rgba(73, 73, 73, 1);
		color: #FFFFFF;
	}

	.footer-box {
		overflow: hidden;
		padding: 30px 0;
	}

	.footer-left {
		float: left;
		width: 30%;
		height: 100px;
	}

	.footer-company {
		font-size: 30px;
		margin: 20px 0 5px 0;
		font-weight: bold;
	}

	.footer-tip {
		font-size: 15px;
	}

	.footer-center {
		float: left;
		width: 40%;
		height: 100px;
	}

	.footer-center img {
		width: 100px;
		height: 100px;
		display: block;
		margin: 0 auto;
	}

	.footer-right {
		float: right;
		width: 30%;
		height: 100px;
		text-align: right;
		font-size: 15px;
	}

	.footer-phone {
		overflow: hidden;
		margin-top: 5px;
	}

	.footer-mobile {
		overflow: hidden;
	}

	.footer-email {
		overflow: hidden;
	}

	.footer-icon {
		width: 30px;
		height: 30px;
		float: right;
	}

	.footer-title {
		float: right;
		height: 30px;
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/home.vue